const {cxt} = require("./context");

const boolean = [
  'boolean'
];

const booleanRequired = [
  'required',
  'boolean'
];

const requiredFalse = [
  'required',
  'boolean',
  cxt('boolean', { expectedValue: false })
];

const requiredTrue = [
  'required',
  'boolean',
  cxt('boolean', { expectedValue: true })
];

module.exports = {
  boolean,
  booleanRequired,
  requiredFalse,
  requiredTrue,
};